export enum QUICKFILTER {
    MAX_RANGE = 30,
    DATE_FORMAT = 'YYYY-MM-DD',
}